import {observable} from 'mobx';
import {construct, createInstance, ModelProperties} from 'utils';
import {SeoApp} from './seo-app';
import {Language} from './language';

export class SeoAppLanguage {
    @observable appId!: number;

    @observable languageId!: number;

    @observable enabled!: boolean;

    @observable published!: boolean;

    @observable language?: Language;

    @observable app?: SeoApp;

    constructor(settings?: ModelProperties<SeoAppLanguage>) {
        if (settings) {
            construct(this, settings);
            this.app = createInstance(SeoApp, settings.app);
            this.language = createInstance(Language, settings.language);
        }
    }
}